import { render, staticRenderFns } from "./ModalDeleteBanner.vue?vue&type=template&id=2ea6d81c&scoped=true"
import script from "./ModalDeleteBanner.vue?vue&type=script&lang=js"
export * from "./ModalDeleteBanner.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteBanner.vue?vue&type=style&index=0&id=2ea6d81c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea6d81c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
